/* ============================================================
   GOBLIN GEAR — Shopify storefront JS
   Real AJAX cart (/cart/add.js, /cart.js), theme toggle,
   predictive search (/search/suggest.json), free-shipping bar,
   glitch system, size guide, pop-up. Masked. But known.
   ============================================================ */
(function () {
  'use strict';
  var root = document.documentElement;
  var THRESH = window.GG_SHIP_THRESHOLD || 7500; // cents
  function money(cents) {
    var s = (cents / 100).toFixed(2);
    return (window.GG_MONEY_FORMAT || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, s).replace(/\$\{\{.*?\}\}/, '$' + s);
  }
  function fmtSimple(cents){ return '$' + (cents/100).toFixed(2); }

  /* ---------------- THEME TOGGLE ---------------- */
  var LOCK = root.getAttribute('data-theme-lock');
  function applyTheme(t){ root.setAttribute('data-theme', t); try{ localStorage.setItem('gg-theme', t);}catch(e){} document.querySelectorAll('.theme-toggle').forEach(function(b){ b.setAttribute('aria-pressed', t==='dark'); }); }
  document.addEventListener('click', function(e){ var t=e.target.closest('.theme-toggle'); if(!t||LOCK) return; applyTheme(root.getAttribute('data-theme')==='dark'?'light':'dark'); });

  /* ---------------- MOBILE NAV + SHOP ACCORDION ---------------- */
  var navToggle = document.getElementById('navToggle'), navLinks = document.getElementById('navLinks');
  if (navToggle && navLinks) {
    navToggle.addEventListener('click', function(){ var o=navLinks.classList.toggle('open'); document.body.classList.toggle('nav-open', o); });
    navLinks.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', function(){ if(!a.classList.contains('nav-trigger')){ document.body.classList.remove('nav-open'); navLinks.classList.remove('open'); } }); });
  }
  (function(){
    var trigger=document.getElementById('shopTrigger'), mega=document.getElementById('megaMenu'), wrap=trigger&&trigger.closest('.nav-shop');
    if(!trigger) return; var mob=function(){return window.matchMedia('(max-width:720px)').matches;};
    if(mega){
      var open=function(){mega.classList.add('open');trigger.setAttribute('aria-expanded','true');};
      var close=function(){mega.classList.remove('open');trigger.setAttribute('aria-expanded','false');};
      trigger.addEventListener('click', function(e){ e.preventDefault(); if(mob()){ if(wrap) wrap.classList.toggle('open'); } else { mega.classList.contains('open')?close():open(); } });
      document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });
      document.addEventListener('click', function(e){ if(!mob()&&!mega.contains(e.target)&&!trigger.contains(e.target)) close(); });
    } else { trigger.addEventListener('click', function(e){ if(mob()){ e.preventDefault(); if(wrap) wrap.classList.toggle('open'); } }); }
  })();

  /* Cart Drawer v2 (assets/gg-cart.js) owns the cart when present; this legacy cart only runs without it. */
  if(!window.GG_CART_V2){
  /* ---------------- AJAX CART ---------------- */
  var overlay=document.getElementById('overlay'), drawer=document.getElementById('cartDrawer');
  function openCart(){ if(drawer) drawer.classList.add('open'); if(overlay) overlay.classList.add('open'); }
  function closeCart(){ if(drawer) drawer.classList.remove('open'); if(overlay) overlay.classList.remove('open'); }
  window.ggOpenCart = openCart;

  function renderCart(cart){
    var countEl=document.getElementById('cartCount'), subEl=document.getElementById('cartSubtotal'), body=document.getElementById('cartBody');
    if(countEl) countEl.textContent = cart.item_count;
    if(subEl) subEl.textContent = fmtSimple(cart.total_price);
    if(body){
      body.innerHTML = cart.items.length ? cart.items.map(function(i){
        return '<div class="cart-item" data-key="'+i.key+'"><div class="ci-img">'+(i.image?'<img src="'+i.image+'" alt="">':'')+'</div>'+
          '<div><h4>'+i.product_title+'</h4><div class="ci-meta">'+(i.variant_title&&i.variant_title!=='Default Title'?i.variant_title+' · ':'')+'Qty '+i.quantity+
          ' · <button class="ci-remove" data-key="'+i.key+'" style="background:none;border:0;color:var(--text-dim);cursor:pointer;text-decoration:underline;font-size:0.78rem">Remove</button></div></div>'+
          '<div class="ci-price">'+fmtSimple(i.final_line_price)+'</div></div>';
      }).join('') : '<p style="color:var(--text-dim);padding:40px 0;text-align:center;font-size:0.92rem">Your cart is empty. Go arm yourself.</p>';
      body.querySelectorAll('.ci-remove').forEach(function(b){ b.addEventListener('click', function(){ changeQty(b.dataset.key, 0); }); });
    }
    updateShipBar(cart.total_price);
  }
  function refreshCart(open){ fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){ renderCart(c); if(open) openCart(); }); }
  function addToCart(id, qty, selling_plan){
    var b={ items:[{ id:id, quantity:qty||1 }] };
    if(selling_plan) b.items[0].selling_plan = selling_plan;
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(b)})
      .then(function(r){return r.json();}).then(function(){ refreshCart(true); });
  }
  function changeQty(key, qty){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){return r.json();}).then(renderCart);
  }
  window.ggAddVariant = addToCart;

  // delegate any [data-variant-id] add button
  document.addEventListener('click', function(e){
    var btn=e.target.closest('[data-variant-id]'); if(!btn) return;
    e.preventDefault();
    if(btn.getAttribute('data-variant-id')){ addToCart(btn.getAttribute('data-variant-id'), parseInt(btn.getAttribute('data-qty'))||1, btn.getAttribute('data-selling-plan')||null); }
  });
  var cartBtn=document.getElementById('cartBtn'), cartClose=document.getElementById('cartClose');
  if(cartBtn) cartBtn.addEventListener('click', function(e){ e.preventDefault(); openCart(); });
  if(cartClose) cartClose.addEventListener('click', closeCart);
  if(overlay) overlay.addEventListener('click', closeCart);
  refreshCart(false);

  /* ---------------- FREE-SHIPPING BAR ---------------- */
  function ensureShipBar(){ var f=document.querySelector('.cart-foot'); if(!f||document.getElementById('shipBar')||THRESH<=0) return; var b=document.createElement('div'); b.id='shipBar'; b.className='ship-bar'; b.innerHTML='<p class="sb-msg" id="sbMsg"></p><div class="sb-track"><div class="sb-fill" id="sbFill"></div></div>'; f.insertBefore(b, f.firstChild); }
  function updateShipBar(total){ if(THRESH<=0) return; ensureShipBar(); var m=document.getElementById('sbMsg'), fl=document.getElementById('sbFill'); if(!m||!fl) return; var pct=Math.min(total/THRESH,1)*100; fl.style.width=pct+'%'; if(total>=THRESH){ m.innerHTML='🟢 You\'ve unlocked <b>FREE U.S. shipping</b>'; fl.classList.add('done'); } else { m.innerHTML='You\'re <b>'+fmtSimple(THRESH-total)+'</b> away from free shipping'; fl.classList.remove('done'); } }

  }

  /* ---------------- PREDICTIVE SEARCH ---------------- */
  (function(){
    var btn=document.getElementById('searchBtn'), ov=document.getElementById('ggSearch'); if(!ov) return;
    var input=document.getElementById('ggSearchInput'), results=document.getElementById('ggSearchResults');
    function open(){ ov.classList.add('open'); document.body.style.overflow='hidden'; setTimeout(function(){input.focus();},60); }
    function close(){ ov.classList.remove('open'); document.body.style.overflow=''; }
    var t;
    function search(q){
      if(!q.trim()){ results.innerHTML=''; return; }
      clearTimeout(t); t=setTimeout(function(){
        fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=8',{headers:{'Accept':'application/json'}})
          .then(function(r){return r.json();}).then(function(d){
            var items=(d.resources&&d.resources.results&&d.resources.results.products)||[];
            results.innerHTML = items.length ? '<div class="gg-search-label">'+items.length+' results</div>'+items.map(function(p){
              var img=p.image||(p.featured_image&&p.featured_image.url)||'';
              return '<a class="gg-search-item" href="'+p.url+'"><span class="gsi-img">'+(img?'<img src="'+img+'" alt="">':'')+'</span><span class="gsi-main"><span class="gsi-cat">'+(p.product_type||'Goblin Gear')+'</span><span class="gsi-name">'+p.title+'</span></span><span class="gsi-price">'+(p.price?fmtSimple(p.price):'')+'</span></a>';
            }).join('') : '<p class="gg-search-empty">No gear matches “'+q+'”.</p>';
          });
      },180);
    }
    if(btn) btn.addEventListener('click', function(e){ e.preventDefault(); open(); });
    var x=document.getElementById('ggSearchX'); if(x) x.addEventListener('click', close);
    ov.addEventListener('click', function(e){ if(e.target===ov) close(); });
    if(input) input.addEventListener('input', function(){ search(input.value); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });
  })();

  /* ---------------- SIZE GUIDE ---------------- */
  (function(){
    var modal=document.getElementById('ggSizeGuide'); if(!modal) return;
    function open(){ modal.classList.add('open'); document.body.style.overflow='hidden'; }
    function close(){ modal.classList.remove('open'); document.body.style.overflow=''; }
    var x=modal.querySelector('.gg-modal-x'); if(x) x.addEventListener('click', close);
    modal.addEventListener('click', function(e){ if(e.target===modal) close(); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });
    document.querySelectorAll('[data-size-guide]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); open(); }); });
  })();

  /* ---------------- SCROLL REVEAL ---------------- */
  var reveals=document.querySelectorAll('[data-reveal]');
  function show(el){ el.classList.add('in'); }
  if(reveals.length && 'IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){ es.forEach(function(en){ if(en.isIntersecting){ show(en.target); io.unobserve(en.target); } }); },{threshold:0,rootMargin:'0px 0px -6% 0px'});
    reveals.forEach(function(el){ io.observe(el); });
    requestAnimationFrame(function(){ reveals.forEach(function(el){ var r=el.getBoundingClientRect(); if(r.top<innerHeight*0.92&&r.bottom>0){ show(el); io.unobserve(el);} }); });
    setTimeout(function(){ reveals.forEach(show); }, 2500);
  } else { reveals.forEach(show); }

  /* ---------------- GLITCH SYSTEM (both themes) ---------------- */
  (function(){
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.punch-word').forEach(function(el){
      if(el.classList.contains('glitch')||!el.textContent.trim()) return;
      el.setAttribute('data-glitch-text', el.textContent); el.classList.add('punch-glitch');
      el.addEventListener('mouseenter', function(){ el.classList.remove('gl-fire'); void el.offsetWidth; el.classList.add('gl-fire'); });
      el.addEventListener('animationend', function(){ el.classList.remove('gl-fire'); });
    });
    var heads=document.querySelectorAll('.section-head h2, .section-top h2, .hero h1, .lb-copy h2, .showcase h2, .cta-band h2, .col-hero h1, .page-head h1, .kit-hero h1, .addon-head h2');
    heads.forEach(function(h){ h.classList.add('glitch-in'); });
    if('IntersectionObserver' in window){
      var io2=new IntersectionObserver(function(es){ es.forEach(function(en){ if(en.isIntersecting){ var el=en.target; el.classList.add('gl-fire'); el.addEventListener('animationend', function h(){ el.classList.remove('gl-fire'); el.removeEventListener('animationend', h); }); io2.unobserve(el);} }); },{threshold:0.25});
      heads.forEach(function(h){ io2.observe(h); });
    }
  })();

  /* ---------------- POP-UP ---------------- */
  (function(){
    var pop=document.getElementById('ggPopup'); if(!pop) return;
    try{ if(localStorage.getItem('gg-pop-seen')) return; }catch(e){}
    function close(){ pop.classList.remove('show'); try{localStorage.setItem('gg-pop-seen','1');}catch(e){} }
    pop.querySelectorAll('[data-pop-close]').forEach(function(b){ b.addEventListener('click', close); });
    pop.addEventListener('click', function(e){ if(e.target===pop) close(); });
    var delay=(parseInt(pop.getAttribute('data-delay'))||4)*1000;
    setTimeout(function(){ pop.classList.add('show'); }, delay);
  })();
})();
